import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "home-template"
    }}>{`Home Template`}</h2>
    <p>{`In our theme we have provided home template.`}</p>
    <ol>
      <li parentName="ol">{`Add new page.`}</li>
      <li parentName="ol">{`Input the page title`}</li>
      <li parentName="ol">{`Set homepage template`}</li>
      <li parentName="ol">{`Finally publish it.`}</li>
    </ol>
    <p><img alt="1. Home Page" src={require("./images/home_page/sc-01.png")} /></p>
    <p><img alt="1. Home Page" src={require("./images/home_page/sc-02.png")} /></p>
    <p><img alt="1. Home Page" src={require("./images/home_page/sc-03.png")} /></p>
    <pre><code parentName="pre" {...{}}>{`Customize -> Cartsy Lite Theme Panel -> Home -> Banner
`}</code></pre>
    <p><img alt="1. Home Page banner setting" src={require("./images/home_page/sc-04.png")} /></p>
    <pre><code parentName="pre" {...{}}>{`Customize -> Header Image
`}</code></pre>
    <p><img alt="1. Home Page banner setting" src={require("./images/home_page/sc-05.png")} /></p>
    <pre><code parentName="pre" {...{}}>{`Customize -> Cartsy Lite Theme Panel -> Home -> Products
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`Home page other's product control inherit by Customizing ▸ WooCommerce ▸ Product Catalog
`}</code></pre>
    <p><img alt="1. Home Page product setting" src={require("./images/home_page/sc-06.png")} /></p>
    <pre><code parentName="pre" {...{}}>{`Customize -> Cartsy Lite Theme Panel -> Home -> Category
`}</code></pre>
    <p><img alt="1. Home Page sidebar setting" src={require("./images/home_page/sc-07.png")} /></p>
    <p>{`To change the default home page to newly created custom home layout page, create an empty `}<inlineCode parentName="p">{`blog page`}</inlineCode>{` and go to the `}<inlineCode parentName="p">{`Settings -> Reading -> Change homepage display to static`}</inlineCode></p>
    <p><img alt="1. set home page" src={require("./images/home_page/sc-08.png")} /></p>
    <p><img alt="1. set blog page" src={require("./images/home_page/sc-09.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      